export default __webpack_public_path__ + "static/media/eatBurger.07bd9e62.png";